import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { UpdateDatabaseService } from './update-database.service';
import { UpdateDatabaseListComponent } from './components/update-database-list/update-database-list.component';
import { UpdateDatabaseRoutingModule } from './update-database-routing.module';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    UpdateDatabaseRoutingModule,
    SharedModule,
  ],
  declarations: [
    UpdateDatabaseListComponent
  ],
  exports: [
    UpdateDatabaseListComponent
  ],
  providers: [
    UpdateDatabaseService
  ],
  schemas: [],
})
export class UpdateDatabaseModule { }
